/**
 * A turn that ended without `done` or `refusal` (a deploy's 30s
 * deregistration, a dropped connection — platform design §12.3). No frame
 * draws this state; it reuses the same `EmptyState` shell `Refusal` and the
 * dashboard's own empty cards share, because the property that matters is
 * shared with them too: never an error toast, the question stays exactly as
 * asked and the reader can retry it in place.
 */

import { RotateCcw } from 'lucide-react';
import type { ReactNode } from 'react';

import { EmptyState } from '../../../chrome/state';
import { Button } from '../../../ui/button';
import { at } from './messages';

/** `message` is the server's own reason, when the turn failed rather than
 *  being cut. */
export function Interrupted(props: { onAskAgain: () => void; message?: string }): ReactNode {
  return (
    <EmptyState
      icon={RotateCcw}
      title={props.message === undefined ? at('interrupted.title') : at('failed.title')}
      description={props.message ?? at('interrupted.description')}
      action={
        <Button type="button" variant="outline" onClick={props.onAskAgain}>
          {at('interrupted.askAgain')}
        </Button>
      }
    />
  );
}
